import React, {useMemo, useState} from 'react';
import {useIntl} from 'react-intl';
// @ts-ignore
import {useTable} from 'react-table';
import * as actions from '../../actions/notificationsActions';
import * as columnFormatters from '../../../_common/column-formatters';
import * as customColumnFormatters from '../column-formatters';
import {useNotificationsContext} from '../../contexts/NotificationsContext';
import useInfiniteScrollControl from '../../../_common/components/_custom-hooks/useInfiniteScrollControl';
import CommonGrid from '../../../_common/components/CommonGrid';
import SortingColumnHeader from "../../../_common/components/SortingColumnHeader/SortingColumnHeader";
import {NotificationRow} from "../../types";
import CommonGridSpinner from "../../../_common/components/CommonGridSpinner";

export default function UsersActionsTable() {
  const {formatMessage} = useIntl();
  const prefix = 'notifications-column';
  const [tableRows, setTableRows] = useState<NotificationRow[]>([]);
  const columns = useMemo(() => [
    {
      accessor: 'sentAt',
      Header:
        <SortingColumnHeader
          text={formatMessage({id: `${prefix}-sentAt`, defaultMessage: 'Sent at'})}
          fieldName={'sentAt'}
          useContext={useNotificationsContext}
          showDefaultIcon={true}
        />
    },
    {
      accessor: 'subject',
      Header:
        <SortingColumnHeader
          text={formatMessage({id: `${prefix}-subject`, defaultMessage: 'Subject'})}
          fieldName={'subject'}
          useContext={useNotificationsContext}
        />
    },
    {
      accessor: 'sender',
      Header:
        <SortingColumnHeader
          text={formatMessage({id: `${prefix}-sender`, defaultMessage: 'Sender'})}
          fieldName={'sender'}
          useContext={useNotificationsContext}
        />
    },
    {
      accessor: 'type',
      Header:
        <SortingColumnHeader
          text={formatMessage({id: `${prefix}-type`, defaultMessage: 'type'})}
          fieldName={'type'}
          useContext={useNotificationsContext}
        />
    },
    {
      accessor: 'receiver',
      Header:
        <SortingColumnHeader
          text={formatMessage({id: `${prefix}-receiver`, defaultMessage: 'receiver'})}
          fieldName={'receiver'}
          useContext={useNotificationsContext}
        />
    },
    {
      accessor: 'docID',
      Header:
        <SortingColumnHeader
          text={formatMessage({id: `${prefix}-docID`, defaultMessage: 'ID'})}
          fieldName={'docID'}
          useContext={useNotificationsContext}
        />
    },
    {
      accessor: 'status',
      Header:
        <SortingColumnHeader
          text={formatMessage({id: `${prefix}-status`, defaultMessage: 'Status'})}
          fieldName={'status'}
          useContext={useNotificationsContext}
        />
    },
  ], []);
  const data = useMemo(
    () =>
      tableRows.map((item) => ({
        sentAt: columnFormatters.DateColumnFormatter(item.sentAt, true),
        subject: columnFormatters.BoldColumnFormatter(item.subjectName),
        docID: columnFormatters.BoldColumnFormatter(item.docID),
        type: customColumnFormatters.TypeColumnFormatter(item.typeID),
        sender: columnFormatters.BoldColumnFormatter(
          [9, 10, 11].includes(item.subjectID)
          ? 'no-reply@accuraiser.com'
          : [item.senderFirstName, item.senderLastName].filter(Boolean).join(' ')
        ),
        receiver: columnFormatters.SeveralItemsColumnFormatter([item.receiverFullName, item.target]),
        status: customColumnFormatters.StatusColumnFormatter(item.statusID, item.statusText),
      })),
    [tableRows]
  );

  const infiniteScrollProps = useInfiniteScrollControl({
    currentStateStoreId: 'notificationsReducer',
    UIContext: useNotificationsContext(),
    getNewEntities: actions.getNotifications,
    getNextEntities: actions.getNextNotifications,
    onEntitiesChange: (entities?: NotificationRow[]) => {
      entities
        ? setTableRows(entities)
        : setTableRows([]);
    },
    dataLength: tableRows.length,
    scrollableTarget: 'scrollContainer',
    scrollThreshold: 0.9,
    loader: <CommonGridSpinner/>,
    style: {
      overflow: 'inherit',
    },
  });

  return (
    <CommonGrid
      infiniteScrollProps={infiniteScrollProps}
      {...useTable({columns, data})}
    />
  );
}